module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.hotList) ? _c('div', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "first"
  }, [_c('span', {
    staticClass: "firstErji"
  }), _vm._v(" "), _c('span', {
    staticClass: "firstBofang"
  }), _vm._v(" "), _c('i', {
    staticClass: "firstI"
  }, [_vm._v(_vm._s(_vm.hotList[0].duration))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "http://y.gtimg.cn/music/photo_new/T002R300x300M000002sib2i06iuRx.jpg?max_age=2592000",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("shortTitle")(_vm.hotList[0].filename)))])]), _vm._v(" "), _c('section', {
    staticClass: "middle"
  }, [_c('span', {
    staticClass: "firstErji"
  }), _vm._v(" "), _c('span', {
    staticClass: "firstBofang"
  }), _vm._v(" "), _c('i', {
    staticClass: "firstI"
  }, [_vm._v(_vm._s(_vm.hotList[1].duration))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "//y.gtimg.cn/music/photo_new/T002R300x300M000000nKeGK4Fy9tu.jpg?max_age=2592000",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("shortTitle")(_vm.hotList[1].filename)))])]), _vm._v(" "), _c('section', [_c('span', {
    staticClass: "erji"
  }), _vm._v(" "), _c('span', {
    staticClass: "bofang"
  }), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.hotList[2].duration))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "//y.gtimg.cn/music/photo_new/T002R300x300M000002glrSP3MSICO.jpg?max_age=2592000",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("shortTitle")(_vm.hotList[2].filename)))])]), _vm._v(" "), _c('section', {
    staticClass: "four"
  }, [_c('span', {
    staticClass: "erji"
  }), _vm._v(" "), _c('span', {
    staticClass: "bofang"
  }), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.hotList[3].duration))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "//y.gtimg.cn/music/photo_new/T002R300x300M000000cKyUv3XjHPm.jpg?max_age=2592000",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("shortTitle")(_vm.hotList[3].filename)))])]), _vm._v(" "), _c('section', {
    staticClass: "middle"
  }, [_c('span', {
    staticClass: "erji"
  }), _vm._v(" "), _c('span', {
    staticClass: "bofang"
  }), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.hotList[4].duration))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "//y.gtimg.cn/music/photo_new/T002R300x300M000003Nhohk0w0hey.jpg?max_age=2592000",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("shortTitle")(_vm.hotList[4].filename)))])]), _vm._v(" "), _c('section', [_c('span', {
    staticClass: "erji"
  }), _vm._v(" "), _c('span', {
    staticClass: "bofang"
  }), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.hotList[5].duration))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": "//y.gtimg.cn/music/photo_new/T002R300x300M000002zVHhH3WaYou.jpg?max_age=2592000",
      "alt": ""
    }
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm._f("shortTitle")(_vm.hotList[5].filename)))])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mainTitle"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v("热门推荐")]), _vm._v(" "), _c('span', {
    staticClass: "more"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f972ac2"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhot.vue
// module id = 242
// module chunks = 0